/**
 * Level focus API client — reads the level practice is served at
 * (`GET /practice/focus-level`).
 *
 * `ownLevelStream` is the student's profile pair. A student has one level per
 * subject, set by their class or enrolment, so they never write a level: the
 * server refuses a student's `PATCH` and reports `focusLevelStream: null`.
 *
 * Self-only by construction: the call accepts no user id, and the level never
 * becomes a client-supplied override on read routes.
 */
import { fetchWithConfig } from './apiUtils';

export interface LevelStreamPair {
  orgLevel: string;
  examLevel: string | null;
}

export interface LevelFocusResponse {
  /** A served level other than the profile pair; always null for a student. */
  focusLevelStream: LevelStreamPair | null;
  /** One level per subject the student studies, maths first. */
  levelStreamOptions: LevelStreamPair[];
  /** The student's profile pair; this remains the diagnostic/prior cohort. */
  ownLevelStream: LevelStreamPair | null;
}

const ENDPOINT = '/practice/focus-level';

export const levelFocusApi = {
  async get(token: string): Promise<LevelFocusResponse> {
    return fetchWithConfig<LevelFocusResponse>(ENDPOINT, {
      method: 'GET',
      authToken: token,
    });
  },
};
